import { Component, Input, OnChanges } from "@angular/core";
import { DomHelper, HorizontalListData, MessageService, WelcomeCall } from "common";
import { EntityWelcomeCallWidgetAdapter } from "./entity-welcome-call-widget.data";

@Component({
    selector: "ifb-entity-welcome-call-widget",
    templateUrl: "./entity-welcome-call-widget.component.html",
    providers: [EntityWelcomeCallWidgetAdapter],
    standalone: false
})
export class EntityWelcomeCallWidgetComponent implements OnChanges {
  @Input()
  welcomeCallData: WelcomeCall;

  listItems: HorizontalListData[];

  constructor(
    private readonly adapter: EntityWelcomeCallWidgetAdapter,
    private readonly messageService: MessageService,
  ) {}

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.welcomeCallData);
  }

  copy(value: string): void {
    DomHelper.copy(value);
    this.messageService.info("Link copied");
  }
}